var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-linkedin',
                        view: publicPath + 'sprite.svg#view-icon-linkedin',
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };